export function toggleArrayValue<T = string>(array: T[], value: T): T[] {
  return array.includes(value)
    ? [...array].filter(v => v !== value)
    : [...array, value];
}
